import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '../../../components/ui/button';

type TablePaginationProps = {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export function TablePagination({
  page,
  totalPages,
  onPageChange,
}: TablePaginationProps): JSX.Element {
  return (
    <div className="flex items-center justify-center gap-2 py-2">
      <Button
        variant="outline"
        size="sm"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        className="gap-1"
      >
        <ChevronLeft className="size-4" />
        Пред
      </Button>
      <span className="text-sm text-muted-foreground px-2">
        Стр. {page} из {totalPages}
      </span>
      <Button
        variant="outline"
        size="sm"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className="gap-1"
      >
        След
        <ChevronRight className="size-4" />
      </Button>
    </div>
  );
}
